module.exports = {
    apiKey: "AIzaSyDIMUAX_W9phldcDD5aWJDA_UIDPM2YXME",
    authDomain: "balus-local.firebaseapp.com",
    databaseURL: "https://balus-local.firebaseio.com",
    projectId: "balus-local",
    storageBucket: "balus-local.appspot.com",
    messagingSenderId: "561705543654"
};



// WEBPACK FOOTER //
// ../etc/config/firebase/localhost.js